/**
 * @module business 
 *  Apis must need auth details to trigger url - AuthApi
 */

import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
const apiVersion = 'api';
import ApiHelper from '@/controllers/ApiHelpers';

export default {
  /**
   * Fetch Business branding
   */
  fetchBusinessBrandingProfile() {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/all`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  /**
   * Create business branding
   * @param data — includes name, colors, logo, favicon, domain, googleAnalyticsKey, cashRounding, etc.
   */
  createBusinessBrandingProfile(data) {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/create`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },


  /**
   * Update business branding
   * @param data — includes name, colors, logo, favicon, domain, googleAnalyticsKey, cashRounding, etc.
   */
  updateBusinessBrandingProfile(brandingId, data) {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/${brandingId}/update`;
    return AuthApis.patchApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  removeBusinessBrandingProfile(brandingId) {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/${brandingId}/remove`;
    return AuthApis.deleteApi(url, null)
      .then(res => res)
      .catch(err => {
        console.log(err)
        // ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  businessBrandingLocations(brandingId) {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/${brandingId}/locations/all`;
    return AuthApis.getApi(url, null)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  },

  syncLocationsToBrandingProfile(brandingId, data) {
    const url = `${Env.loginUrl}/${apiVersion}/business-brand-profiles/${brandingId}/locations/sync`;
    return AuthApis.postApi(url, null, data)
      .then(res => res)
      .catch(err => {
        ApiHelper.detectStatusAndRedirect(err);
        return err;
      });
  }

}